import { memo } from "react";
import styles from "./StaticCard.module.scss";

type Props = {
	label: string;
	count: number;
	percentage: number;
	icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
};

const StaticCard: React.FC<Props> = memo((props: Props) => {
	return (
		<div className={styles.staticCard}>
			<span className={styles.cardLabel}>{props.label}</span>
			<span className={styles.cardNumber}>
				{<props.icon className={styles.percentageIcon} />}
				{` ${props.count}`}
			</span>
			{/* <div className={styles.percentageContainer}>
				<span className={styles.percentageNumber}>
                    {props.percentage}%
                </span>
                <span className={styles.percentageText}>
                    from last period
                </span>
			</div> */}
		</div>
	);
});

export default StaticCard;
